<template>
    <div class="component order-status">
        <template v-if="isLoading && !order">
            <v-progress-circular
                :size="16"
                indeterminate
                color="#2f9bd9"
            ></v-progress-circular>
        </template>

        <template v-if="!isLoading && order">
            <v-chip
                    small
                    color="#2f9bd9"
                    text-color="white"
            >
                <v-avatar left>
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="18" height="18" viewBox="0 0 24 24"><path fill="#FFFFFF" d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" /></svg>
                </v-avatar>
                <span>{{displayStatus}}</span>
            </v-chip>
        </template>

        <template v-if="!isLoading && error">
            <v-chip
                    small
                    color="gray"
                    text-color="red"
            >
                {{error.statusText}}
            </v-chip>
        </template>
    </div>
</template>

<script type="text/babel">
    import {VChip, VIcon, VAvatar, VProgressCircular} from 'vuetify/lib'
    import RunbuggyClient from '@/clients/runBuggyApi'

    const statusTranslations = {
        ACCEPTED: 'Accepted',
        ASSIGNED: 'Assigned',
        AVAILABLE: 'Available',
        AVAILABLE_PRIORITY: 'Available (Priority)',
        CANCELED: 'Canceled',
        CLAIMED: 'Claimed',
        COMPLETE: 'Complete',
        COMPLETED: 'Completed',
        CREATED: 'Created',
        DELIVERED: 'Delivered',
        DETACHED: 'Detached',
        DRAFT: 'Draft',
        DRAFT_CREATED: 'Draft Created',
        DRIVER_ACCEPTED: 'Driver Accepted',
        DRIVER_ARRIVED: 'Driver Arrived',
        DRIVER_ASSIGNED: 'Driver Assigned',
        DRIVER_REJECTED: 'Driver Rejected',
        ERROR: 'Need Attention',
        PAYOUT_COMPLETE: 'Payout Complete',
        PAYOUT_PROCESSING: 'Payout Processing',
        READY: 'Detached',
        REJECTED: 'Rejected',
        SIGNATURE_ON_PICKUP: 'Picked Up',
        UNCLAIMED: 'Unclaimed',
        VEHICLES_CLAIMED: 'Vehicles Claimed',
        VEHICLES_DELIVERED: 'Vehicles Delivered',
        VEHICLES_PICKEDUP: 'Vehicles Picked-Up',
        VEHICLES_SIGNATURE_DELIVERED: 'Vehicles Signature Delivered',
        VEHICLES_SIGNATURE_PICKEDUP: 'Vehicles Signature Picked-Up',
        VEHICLES_UNCLAIMED: 'Vehicles Unclaimed'
    }

    export default {
        name: 'components-order-status',
        watch: {},
        props: {
            orderType: {
                required: false,
                default: 'shipper'
            },
            orderId: {
                required: true
            },
            token: {
                required: false
            }
        },
        data() {
            return {
                isLoading: true,
                order: undefined,
                error: undefined
            }
        },
        methods: {
            apiCall() {
                let orderType = '';
                let call = RunbuggyClient.getOrderById;
                switch (this.orderType) {
                    case 'transportation':
                        orderType = 'transportation-';
                        call =  RunbuggyClient.getTransportationOrderById;
                        break;
                    case 'vehicleTransfer':
                        orderType = 'vehicle-transfer-';
                        call = RunbuggyClient.getVehicleTransferOrderById;
                        break;
                    default:
                        break;
                }
                return call(this.orderId, this.token, orderType);
            }
        },
        computed: {
            displayStatus() {
                return this.order ? statusTranslations[this.order.status] : this.order.status;
            }
        },
        created() {
        },
        mounted() {
            this.apiCall()
            .then((response) => {
                this.order = response.data;
            })
            .catch((error) => {
                console.log(error);
                this.error = error.response;
                this.isLoading = false;
            })
            .finally(() => {
                this.isLoading = false;
            });
        },
        beforeDestroy() {
        },
        mixins: [],
        components: {
            VChip,
            VIcon,
            VAvatar,
            VProgressCircular
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
